import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=1d68f89a&scoped=true&"
import script from "./EditPage.vue?vue&type=script&lang=js&"
export * from "./EditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d68f89a",
  null
  
)

export default component.exports